// El fondo de la portada de Crear (ADR-2026-10-09-asistente-en-crear): los azules de la marca
// en degradado, sin formas ni líneas (ADR-2026-10-09-asistente-en-crear-5; reemplaza a la
// cordillera y a las curvas de nivel).
//
//  • Una AURORA arriba: tres franjas grandes de luz difusa (azul, azul claro, lavanda azulada) que giran
//    y se corren muy despacio, cada una a su ritmo, así el color nunca está quieto del todo.
//  • Un HALO blanco detrás de la caja: la levanta del fondo sin sombra dura.
//  • Un GRANO fino encima de todo (ruido de SVG, muy bajo): le saca lo plano al degradado,
//    como una foto.
//
// Más claro desde 2026-10-15 (pedido del usuario): base más blanca y las franjas de la aurora
// a ~2/3 de su opacidad (ADR-2026-10-15-el-fondo-de-crear-es-mas-claro).

import React from 'react';
import './crear.css';

export const FondoDeCrear: React.FC<{
  className?: string;
  /**
   * La conversación del Asistente está en curso: el color se apaga despacio hacia el gris del
   * lienzo (`#F3F4F8`), así el paso al Canva no es un golpe
   * (ADR-2026-10-13-el-asistente-se-apaga-hacia-el-lienzo).
   */
  atenuado?: boolean;
}> = ({ className = '', atenuado = false }) => (
  <div
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    // Tintes del primario sobre blanco (eran celestes de Atlas escritos a mano): con
    // marca blanca el fondo toma el color del cliente.
    style={{
      background:
        'linear-gradient(180deg, rgb(var(--brand-primary-rgb) / 0.115) 0%, rgb(var(--brand-primary-rgb) / 0.08) 40%, rgb(var(--brand-primary-rgb) / 0.055) 70%, rgb(var(--brand-primary-rgb) / 0.095) 100%), #FFFFFF',
    }}
  >
    {/* La aurora: franjas elípticas, inclinadas y muy desenfocadas. */}
    <span
      className="crear-aurora"
      style={{ left: '-15%', top: '-34%', width: '75%', height: '70%', background: 'linear-gradient(100deg, rgb(var(--brand-primary-rgb) / 0.45), rgb(var(--brand-primary-rgb) / 0) 75%)' }}
    />
    <span
      className="crear-aurora crear-aurora--2"
      style={{ right: '-18%', top: '-30%', width: '70%', height: '62%', background: 'linear-gradient(250deg, rgb(var(--brand-primary-rgb) / 0.36), rgb(var(--brand-primary-rgb) / 0) 70%)' }}
    />
    <span
      className="crear-aurora crear-aurora--3"
      style={{ left: '22%', top: '-24%', width: '56%', height: '46%', background: 'linear-gradient(180deg, rgb(var(--brand-primary-rgb) / 0.3), rgb(var(--brand-primary-rgb) / 0) 80%)' }}
    />
    {/* Abajo, un reflejo del primario muy suave para que el pie no quede vacío. */}
    <span
      className="crear-aurora crear-aurora--3"
      style={{ left: '10%', bottom: '-38%', width: '80%', height: '55%', background: 'radial-gradient(closest-side, rgb(var(--brand-primary-rgb) / 0.16), rgb(var(--brand-primary-rgb) / 0))' }}
    />
    {/* El halo detrás de la caja. */}
    <span
      className="absolute left-1/2 top-[58%] h-[70%] w-[90%] -translate-x-1/2 -translate-y-1/2 rounded-full"
      style={{ background: 'radial-gradient(closest-side, rgba(255,255,255,.6), rgba(255,255,255,0))' }}
    />
    {/* El grano: ruido fractal en gris, a muy baja opacidad, mezclado para no ensuciar el color. */}
    <svg className="absolute inset-0 h-full w-full opacity-[0.07] mix-blend-multiply">
      <filter id="crear-grano">
        <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch" />
        <feColorMatrix type="saturate" values="0" />
      </filter>
      <rect width="100%" height="100%" filter="url(#crear-grano)" />
    </svg>
    {/* El velo del color del lienzo, encima de todo: se prende con la conversación. */}
    <span
      className="crear-velo absolute inset-0 bg-[#F3F4F8]"
      style={{ opacity: atenuado ? 0.9 : 0 }}
    />
  </div>
);

export default FondoDeCrear;
